module.exports = __webpack_public_path__ + "static/img/daiyunying_fuwu.784a4245.png";